import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PipelinesService} from "../../../../pipelines.service";

@Component({
  selector: 'pipelines-panel-property-info',
  standalone: false,
  templateUrl: './pipelines-panel-property-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-property-info.component.scss', '../../pipelines-table.component.scss']
})
export class PipelinesPanelPropertyInfoComponent implements OnInit {
  @Input() detail:any;
  public expanded:boolean = false
  public rows: { label: string; key: string }[][] = [];

  private displayFields: { label: string; key: string }[] = [
    { label: 'City', key: 'city' },
    { label: 'Buildings', key: 'buildings' },
    { label: 'State', key: 'state' },
    { label: 'Total Units', key: 'total_units' },
    { label: 'ZIP Code', key: 'zipcode'},
    { label: 'Total LIHTC Units', key: 'total_lihtc_units'},
    { label: 'County', key: 'county'},
    { label: 'Total Rental Assistance Units', key: 'total_residential_assistance_units'},
    { label: 'Qualified Census Tract', key: 'is_qct'},
    { label: 'Total Market Rate Units', key: 'total_market_rate_units'},
    { label: 'Difficult to Develop Area', key: 'is_dda'},
    { label: 'Total Family Units', key: 'total_family_units'},
    { label: 'Minority Population Percentage', key: 'minority_pop_percent'},
    { label: 'Total Senior Units', key: 'total_senior_units'},
    { label: 'MSA', key: 'msa'},
    { label: 'Drive Path', key: 'drive_folder'},
    { label: 'Full Address', key: 'full_address'},
    { label: 'Description', key: 'description'},
    { label: 'Risk Rating', key: 'risk_rating'}

  ];

  constructor(private _pipelineService: PipelinesService) { }

  ngOnInit(): void {
    this.rows = this._pipelineService.splitExpandedRowChunk(this.displayFields, 2)
  }

  public toggleExpand(){
    this.expanded = !this.expanded
  }



}
